export const CATEGORIES = [
  {
    id: "email",
    label: "E-posta Hesapları",
    labelEn: "Email Accounts",
    icon: "Mail",
    fields: [
      { key: "email", label: "E-posta", type: "text" },
      { key: "password", label: "Parola", type: "password" },
      { key: "smtp_host", label: "SMTP Host", type: "text" },
      { key: "smtp_port", label: "SMTP Port", type: "text" },
      { key: "imap_host", label: "IMAP Host", type: "text" },
      { key: "imap_port", label: "IMAP Port", type: "text" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  {
    id: "server",
    label: "Sunucu Bağlantıları",
    labelEn: "Server Connections",
    icon: "Server",
    fields: [
      { key: "host_ip", label: "Host / IP", type: "text" },
      { key: "ssh_port", label: "SSH Port", type: "text" },
      { key: "username", label: "Kullanıcı", type: "text" },
      { key: "password", label: "Parola", type: "password" },
      { key: "rustdesk_id", label: "RustDesk / AnyDesk ID", type: "text" },
      { key: "rustdesk_password", label: "RustDesk / AnyDesk Parolası", type: "password" },
      { key: "os", label: "İşletim Sistemi", type: "text" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  {
    id: "vpn",
    label: "VPN Kullanıcıları",
    labelEn: "VPN Users",
    icon: "ShieldCheck",
    fields: [
      { key: "gateway_ip", label: "Gateway IP", type: "text" },
      { key: "provider", label: "Sağlayıcı", type: "text" },
      { key: "username", label: "Kullanıcı Adı", type: "text" },
      { key: "password", label: "Parola", type: "password" },
      { key: "shared_key", label: "Shared Key", type: "password" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  {
    id: "firewall",
    label: "Firewall & AP",
    labelEn: "Firewall / Access Point",
    icon: "Cpu",
    fields: [
      { key: "device_model", label: "Cihaz / Model", type: "text" },
      { key: "management_ip", label: "Yönetim IP", type: "text" },
      { key: "port", label: "Port", type: "text" },
      { key: "admin_user", label: "Admin Kullanıcı", type: "text" },
      { key: "admin_password", label: "Admin Parola", type: "password" },
      { key: "ssid", label: "SSID", type: "text" },
      { key: "wifi_password", label: "Wi-Fi Parolası", type: "password" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  {
    id: "idrac",
    label: "iDRAC & Uzak Yönetim",
    labelEn: "iDRAC / Remote Mgmt",
    icon: "HardDrive",
    fields: [
      { key: "idrac_ip", label: "iDRAC IP", type: "text" },
      { key: "port", label: "Port", type: "text" },
      { key: "operator_user", label: "Operatör Kullanıcı", type: "text" },
      { key: "operator_password", label: "Operatör Parolası", type: "password" },
      { key: "admin_user", label: "Admin Kullanıcı", type: "text" },
      { key: "admin_password", label: "Admin Parolası", type: "password" },
      { key: "virtual_console", label: "Virtual Console Tipi", type: "text" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  {
    id: "domain",
    label: "Domain & DNS",
    labelEn: "Domains / DNS",
    icon: "Globe",
    fields: [
      { key: "domain_name", label: "Alan Adı", type: "text" },
      { key: "registrar", label: "Registrar", type: "text" },
      { key: "registrar_user", label: "Registrar Kullanıcı", type: "text" },
      { key: "registrar_password", label: "Registrar Parola", type: "password" },
      { key: "expiry_date", label: "Son Kullanma Tarihi", type: "date" },
      { key: "dns_provider", label: "DNS Sağlayıcı", type: "text" },
      { key: "auto_renew", label: "Otomatik Yenileme", type: "text" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  {
    id: "license",
    label: "Yazılım Lisansları",
    labelEn: "Software Licenses",
    icon: "Key",
    fields: [
      { key: "software_name", label: "Yazılım", type: "text" },
      { key: "license_key", label: "Lisans Anahtarı", type: "password" },
      { key: "seat_count", label: "Koltuk Sayısı", type: "text" },
      { key: "vendor", label: "Satıcı", type: "text" },
      { key: "expiry_date", label: "Son Kullanma Tarihi", type: "date" },
      { key: "support_email", label: "Destek E-posta", type: "text" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  {
    id: "cloud",
    label: "Bulut Hizmetleri",
    labelEn: "Cloud Services",
    icon: "Cloud",
    fields: [
      { key: "provider", label: "Sağlayıcı", type: "text" },
      { key: "account_id", label: "Hesap / Abonelik ID", type: "text" },
      { key: "console_url", label: "Konsol URL", type: "text" },
      { key: "username", label: "Kullanıcı", type: "text" },
      { key: "password", label: "Parola", type: "password" },
      { key: "api_key", label: "API Anahtarı", type: "password" },
      { key: "expiry_date", label: "Yenileme / Bitiş Tarihi", type: "date" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  {
    id: "other",
    label: "Diğer",
    labelEn: "Other Secrets",
    icon: "Lock",
    fields: [
      { key: "username", label: "Kullanıcı", type: "text" },
      { key: "password", label: "Parola", type: "password" },
      { key: "url", label: "URL", type: "text" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
];

export const categoryById = (id) =>
  CATEGORIES.find((c) => c.id === id) || CATEGORIES[CATEGORIES.length - 1];

export const SENSITIVE_KEYS = new Set([
  "password",
  "admin_password",
  "operator_password",
  "wifi_password",
  "license_key",
  "shared_key",
  "registrar_password",
  "rustdesk_password",
]);

export const isSensitive = (key) =>
  SENSITIVE_KEYS.has(key) ||
  /password|secret|key|token/i.test(key);

export const EXPIRY_WARN_DAYS = { domain: 30, license: 30, cloud: 70 };
